import { FETCH_SORTED_PARTNER_LIST_RESPONSE, ALLOCATE_PARTNER_DATA_TO_SERVER_RESPONSE, FETCH_ALLOCATED_PARTNER_DATA_RESPONSE, SEARCH_COUNTERPARTY_RESPONSE, FETCH_PARTNER_PRODUCT_LIST_RESPONSE, FETCH_PARTNER_ORDER_DATA_RESPONSE, UPDATE_ADDITIONAL_DETAILS_RESPONSE, REALLOCATE_PARTNER_DATA_SERVER_RESPONSE } from './action';

const allocatePartnerDataReducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_SORTED_PARTNER_LIST_RESPONSE:
            return {
                ...state,
                sortedPartnerList: action.data.data
            }

        case ALLOCATE_PARTNER_DATA_TO_SERVER_RESPONSE:
            return {
                ...state,
                allocatePartnerResponse: action.data
            }

        case FETCH_ALLOCATED_PARTNER_DATA_RESPONSE:
            return {
                ...state,
                allocatedPartnerData: action.data
            }

        case SEARCH_COUNTERPARTY_RESPONSE:
            return {
                ...state,
                searchCounterpartyData: action.data
            }

        case FETCH_PARTNER_PRODUCT_LIST_RESPONSE:
            return {
                ...state,
                partnerProductList: action.data.data
            }

        case FETCH_PARTNER_ORDER_DATA_RESPONSE:
            return {
                ...state,
                partnerOrderResponse: action.data
            }

        case UPDATE_ADDITIONAL_DETAILS_RESPONSE:
            return {
                ...state,
                updateAdditionalDetailsResponse: action.data
            }

        case REALLOCATE_PARTNER_DATA_SERVER_RESPONSE:
            return {
                ...state,
                reallocatePartnerResponse: action.data
            }

        default:
            return state
    }
}

export default allocatePartnerDataReducer;